<template>
  <div>
    <div class="sifarnik-main-wrapper">
      <div class="sifarnik-item-wrapper">
        <v-dialog v-model="popView" width="600px">
          <v-card class="tarife-unos" color="universal-vcard">
            <div class="universal-vdialog-title">
              <span class="subtitle">
                {{ $t('components.general.suggestion_box.anonymous_box') }}
              </span>
            </div>
            <div></div>

            <div class="sifra-form-wrapper">
              <CustomDropdown
                :id="'drop_head'"
                v-model="new_suggestion.type"
                :drop_items="heads_filter"
                :init_text="$t('components.general.suggestion_box.problem_type')"
              />
            </div>

            <div class="sifra-opis-wrapper">
              <!-- <v-textarea class="universal-vdialog-textfield" type="text"
                                placeholder="Opis tarifne stavke" label="Opis tarifne stavke"
                                v-model="new_suggestion.description"></v-textarea> -->
              <span class="opis-stavke-title">{{ $t('components.general.suggestion_box.description') }}</span>
              <ckeditor
                :editor="editor"
                v-model="new_suggestion.description"
                :config="editorConfig"
              >
              </ckeditor>
              <div class="basic-error-wrapper">
                <InvalidElementsList
                  v-if="errors.length != 0"
                  :error_list="errors"
                />
              </div>
            </div>
            <div class="form-input-wrapper">
              <label class="form-label" for="privici">
                <span>{{ $t('components.general.suggestion_box.attachments') }}</span>
              </label>
              <div
                :class="['loading-spinner', is_hovering ? 'active' : '']"
              ></div>
              <div
                :class="[
                  'file-list-wrapper',
                  'project-attachments',
                  is_hovering ? 'active' : '',
                ]"
                @dragover.prevent="is_hovering = true"
                @dragleave.prevent="is_hovering = false"
                @drop.prevent="drop"
              >
                <div v-if="new_suggestion && new_suggestion.privici" :key="rk">
                  <div
                    class="attachment-row existing"
                    v-for="(privitak, key) in new_suggestion.privici"
                    :key="key"
                  >
                    <span
                      class="existing-attachment"
                      @click="getGraphInvoice(privitak.id)"
                      >{{ privitak.name }}</span
                    >
                    <div
                      class="remove-checklist-item"
                      @click="deleteAttach(privitak, 1)"
                    >
                      <svg
                        width="11"
                        height="11"
                        viewBox="0 0 11 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M9.29826 2.40299C9.47656 2.40299 9.625 2.55103 9.625 2.7394V2.91356C9.625 3.09735 9.47656 3.24998 9.29826 3.24998H1.70218C1.52344 3.24998 1.375 3.09735 1.375 2.91356V2.7394C1.375 2.55103 1.52344 2.40299 1.70218 2.40299H3.03855C3.31001 2.40299 3.54626 2.21003 3.60733 1.93778L3.67732 1.6252C3.78608 1.19941 4.14402 0.916626 4.55367 0.916626H6.44633C6.85152 0.916626 7.21348 1.19941 7.31823 1.60274L7.39311 1.93732C7.45374 2.21003 7.68999 2.40299 7.96189 2.40299H9.29826ZM8.61934 8.76972C8.75886 7.46944 9.00313 4.38031 9.00313 4.34914C9.01205 4.25473 8.98129 4.16535 8.92022 4.09339C8.85469 4.02602 8.77178 3.98615 8.6804 3.98615H2.32307C2.23125 3.98615 2.14388 4.02602 2.08326 4.09339C2.02174 4.16535 1.99143 4.25473 1.99589 4.34914C1.99671 4.35487 2.00547 4.46368 2.02013 4.6456C2.08523 5.45376 2.26654 7.70462 2.38369 8.76972C2.4666 9.55438 2.98145 10.0475 3.7272 10.0654C4.30266 10.0787 4.89551 10.0833 5.50174 10.0833C6.07275 10.0833 6.65267 10.0787 7.24597 10.0654C8.01757 10.0521 8.53197 9.56767 8.61934 8.76972Z"
                          fill="#70707E"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div v-if="sending" class="paznja-spinner">
                  <svg class="dot-spin" viewBox="0 0 50 50">
                    <circle
                      class="path"
                      cx="25"
                      cy="25"
                      r="20"
                      fill="none"
                      stroke-width="5"
                    ></circle>
                  </svg>
                </div>
                <div class="section-divider"></div>
                <div
                  class="attachment-row"
                  v-for="(privitak, key) in temp_privici"
                  :key="100 + key"
                >
                  <span class="new-attachment">{{ privitak.name }}</span>
                  <div
                    class="remove-checklist-item"
                    @click="deleteAttach(privitak, 0)"
                  >
                    <svg
                      width="11"
                      height="11"
                      viewBox="0 0 11 11"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.29826 2.40299C9.47656 2.40299 9.625 2.55103 9.625 2.7394V2.91356C9.625 3.09735 9.47656 3.24998 9.29826 3.24998H1.70218C1.52344 3.24998 1.375 3.09735 1.375 2.91356V2.7394C1.375 2.55103 1.52344 2.40299 1.70218 2.40299H3.03855C3.31001 2.40299 3.54626 2.21003 3.60733 1.93778L3.67732 1.6252C3.78608 1.19941 4.14402 0.916626 4.55367 0.916626H6.44633C6.85152 0.916626 7.21348 1.19941 7.31823 1.60274L7.39311 1.93732C7.45374 2.21003 7.68999 2.40299 7.96189 2.40299H9.29826ZM8.61934 8.76972C8.75886 7.46944 9.00313 4.38031 9.00313 4.34914C9.01205 4.25473 8.98129 4.16535 8.92022 4.09339C8.85469 4.02602 8.77178 3.98615 8.6804 3.98615H2.32307C2.23125 3.98615 2.14388 4.02602 2.08326 4.09339C2.02174 4.16535 1.99143 4.25473 1.99589 4.34914C1.99671 4.35487 2.00547 4.46368 2.02013 4.6456C2.08523 5.45376 2.26654 7.70462 2.38369 8.76972C2.4666 9.55438 2.98145 10.0475 3.7272 10.0654C4.30266 10.0787 4.89551 10.0833 5.50174 10.0833C6.07275 10.0833 6.65267 10.0787 7.24597 10.0654C8.01757 10.0521 8.53197 9.56767 8.61934 8.76972Z"
                        fill="#70707E"
                      />
                    </svg>
                  </div>
                </div>
                <label
                  :class="[
                    'form-input',
                    'attachments-wrapper',
                    is_hovering ? 'active' : '',
                  ]"
                >
                  <div class="items-holder">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      xmlns:avocode="https://avocode.com/"
                      id="SVGDoc"
                      width="14"
                      height="21"
                      version="1.1"
                      viewBox="0 0 14 21"
                    >
                      <defs />
                      <desc>Generated with Avocode.</desc>
                      <g>
                        <g>
                          <title>Shape 3</title>
                          <path
                            d="M6.70195,21.0001c-3.69596,0 -6.70195,-2.81801 -6.70195,-6.283v-8.79622c0,-0.46329 0.40042,-0.83771 0.89347,-0.83771c0.49341,0 0.89371,0.37441 0.89371,0.83771v8.79622c0,2.54002 2.20454,4.60749 4.91476,4.60749c2.71022,0 4.91464,-2.06747 4.91464,-4.60749v-9.21516c0,-1.61676 -1.40285,-2.93198 -3.12746,-2.93198c-1.72472,0 -3.12757,1.31521 -3.12757,2.93198v8.37765c0,0.69265 0.60129,1.25637 1.34039,1.25637c0.73898,0 1.34027,-0.56372 1.34027,-1.25637v-7.9587c0,-0.46329 0.40054,-0.83771 0.89359,-0.83771c0.49329,0 0.89371,0.37441 0.89371,0.83771v7.9587c0,1.61676 -1.40309,2.93188 -3.12757,2.93188c-1.7246,0 -3.12757,-1.31512 -3.12757,-2.93188v-8.37765c0,-2.53992 2.20442,-4.60749 4.91476,-4.60749c2.71022,0 4.91464,2.06757 4.91464,4.60749v9.21516c0,3.46498 -3.00598,6.283 -6.70183,6.283z"
                            fill="#3326ae"
                            fill-opacity="1"
                          />
                        </g>
                      </g>
                    </svg>
                    <span>Dodaj snimak zaslona</span>
                  </div>

                  <input
                    @change="onChange"
                    type="file"
                    accept=".jpg,.jpeg,.JPG,.JPEG,.png,.PNG"
                    id="assetsFieldHandle"
                    ref="file"
                    style="display: none"
                  />
                </label>
              </div>
            </div>
            <div></div>

            <div class="vdialog-buttons-wrapper">
              <div
                class="universal-vdialog-button vbutton-secondary"
                @click="clearNewEdit()"
              >
                {{ $t("repetitive.cancel") }}
              </div>
              <div
                class="universal-vdialog-button vbutton-primary"
                @click="addNewSuggestion()"
              >
                Prijavi
              </div>
            </div>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import CustomMultiselect from "@/components/generalComponents/CustomMultiselect.vue";
import SingleSifra from "@/components/costSheetComponents/sifarnik/SingleSifra.vue";
import RouteTab from "@/components/costSheetComponents/sifarnik/RouteTab.vue";
import sifra_handler from "@/apiCallers/promise_handler_db/sifarnik.js";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import ClassicEditor from "@/plugins/ckeditor_build";
import InvalidElementsList from "@/components/generalComponents/InvalidElementsList.vue";
import CustomSpinner from "@/components/generalComponents/CustomSpinner.vue";
import suggestion_caller from "@/apiCallers/promise_handler_db/suggestionBox.js";

export default {
  components: {
    CustomDropdown,
    CustomMultiselect,
    SingleSifra,
    RouteTab,
    ckeditor: CKEditor.component,
    CustomSpinner,
    InvalidElementsList,
  },
  data() {
    return {
      sending: false,
      errors: [],
      loading: false,
      fetching: false,
      finalni_arr_prikaza: [],
      downloading: null,
      snackbar: false,
      snackTimeout: 4000,
      snackText: "",
      temp_privici: [],
      is_hovering: false,
      rk: 0,
      editor: ClassicEditor,
      editorData: "<p></p>",
      editorConfig: {
        toolbar: {
          items: [
            "heading",
            "|",
            "bold",
            "italic",
            "link",
            "|",
            "undo",
            "redo",
            "|",
            "bulletedList",
            "numberedList",
            "texttransform",
          ],
        },
        link: {
          // Automatically add target="_blank" and rel="noopener noreferrer" to all external links.
          addTargetToExternalLinks: true,
        },
      },
      edit_sifra: {
        uid: "",
        name: "",
        number: "",
        description: "",
        parrent_id: null,
        references: [],
        value: 0,
        other_sifarnik: [],
        type: null,
      },
      editingMode: false,

      delete_screen: false,
      delete_obj: {
        uid: "",
        name: "",
        description: "",
        number: "",
        parrent_id: null,
        references: null,
        value: 0,
        other_sifarnik: [],
        type: null,
      },

      // data for recursion test
      popView: false,
      new_suggestion: {
        type: 1,
        description: "",
      },
      sifra_arr: [],
      selected_type: null,
      single_row_sifra: [],
      heads_sifre: [],
      heads_filter: [],
      selected_head: null,
      all_refferences: [],
      fetching: true,
    };
  },
  async created() {
    await suggestion_caller.getSuggestionTypes().then((resp) => {
      this.heads_filter = resp.data;
    });

    this.fetching = false;
  },

  methods: {
    onChange() {
      const add_files = [this.$refs.file.files[0]];
      const final_files = add_files.filter((file) => file.size < 57671680);
      const num_odbacenih = add_files.length - final_files.length;
      if (num_odbacenih != 0) {
        this.snackbar = true;
        this.snackText = this.$t("bulletin_board_page.popup.odbaceno", {
          num_odbacenih: num_odbacenih,
        });
      }
      this.temp_privici = final_files;
      this.$refs.file.value = null;
    },
    deleteAttach(privitak, type) {
      if (type == 0) {
        this.temp_privici = this.temp_privici.filter(
          (priv) => priv != privitak
        );
      } else {
        this.chosen_nalog.deleted_privici.push(
          this.chosen_nalog.privici.find((priv) => priv.id == privitak.id)
        );
        this.chosen_nalog.privici = this.chosen_nalog.privici.filter(
          (priv) => priv.id != privitak.id
        );
      }
      this.rk++;
    },
    handleKeyDown(event) {
      // Check if Control key (event.ctrlKey) and "B" key (event.key === "b") are pressed simultaneously
      if (event.ctrlKey && event.key === "b") {
        // Call your function or perform the desired action
        this.openSuggestionBox();
      }
    },
    openSuggestionBox() {
      // Your function logic here
      this.popView = !this.popView;
      this.errors = [];
      this.temp_privici = null;
    },
    clearNewEdit: function () {
      this.popView = false;
      this.errors = [];
    },
    resetValues() {
      this.new_suggestion = {
        type: 1,
        description: "",
      };
      this.temp_privici = null;
    },

    addNewSuggestion: async function () {
      this.errors = [];
      if (this.new_suggestion.description.trim() == "") {
        this.errors.push(this.$t('components.general.suggestion_box.fill_description'));
      } else {
        this.sending = true;
        const formData = new FormData();
        if (this.temp_privici != null) {
          for (let i = 0; i < this.temp_privici.length; i++) {
            formData.append("files", this.temp_privici[i]);
          }
        }

        formData.append(
          "new_suggestion",
          JSON.stringify({
            description: this.new_suggestion.description,
            type: this.heads_filter.find(
              (p) => p.id == this.new_suggestion.type
            ).naziv,
          })
        );
        await suggestion_caller.addNewSuggestion(formData).then((resp) => {
          this.sending = false;
          this.resetValues();
          this.popView = false;
        });
      }
    },
  },

  mounted() {
    document.addEventListener("keydown", this.handleKeyDown);

    // this.$store.state.paginacija.title = this.$t("breadcrumbs.sifrarnici");
  },
  beforeDestroy() {
    // Remove event listener when component is destroyed
    document.removeEventListener("keydown", this.handleKeyDown);
  },
};
</script>
